import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { UrlConstants } from '../../../constants/url.constants';
import { ForgotUsernameRequest } from '../../../models/user-profile/forgot-username-request';
import { ForgotPasswordRequest } from '../../../models/user-profile/forgot-password-request';
import { ForgotCredentialsResponse } from '../../../models/user-profile/forgot-credentials-response';

@Injectable({
  providedIn: "root",
})
export class UserProfileService {

  readonly http = inject(HttpClient);

  forgotUsername(emailAddress: string): Observable<ForgotCredentialsResponse> {
    const request: ForgotUsernameRequest = { emailAddress };
    return this.http.post<ForgotCredentialsResponse>(UrlConstants.FORGOT_USERNAME_URL, request);
  }

  forgotPassword(request:  ForgotPasswordRequest): Observable<ForgotCredentialsResponse> {
    return this.http.post<ForgotCredentialsResponse>(UrlConstants.FORGOT_PASSWORD_URL, request);
  }
}

